var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuestion = function SvgQuestion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 9,
    fill: "none",
    viewBox: "0 0 9 9"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 4.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-4 3a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m.092-3.725A1.6 1.6 0 0 0 4 5.291V6.5h1V5.291c0-.257.164-.485.408-.566A1.6 1.6 0 0 0 6.5 3.209v-.256A1.953 1.953 0 0 0 4.547 1H4.5a2 2 0 0 0-2 2h1a1 1 0 0 1 1-1h.047c.526 0 .953.427.953.953v.256a.6.6 0 0 1-.408.566",
    clipRule: "evenodd"
  })));
};
export default SvgQuestion;